module.exports = __webpack_public_path__ + "media/images/favicn/site-cb14a89989ed7fa8257f890f6a10b687.webmanifest";